import axios from 'axios'

export function login (user, pass) {
  const params = new URLSearchParams({
    grant_type: 'password',
    username: user,
    password: pass
  })
  const request = axios.post(`${window.apiConfig.APIURL}token`, params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Oauth2'
    }
  })
  return request
}
export function refreshLogin (refreshToken) {
  const params = new URLSearchParams({
    grant_type: 'refresh_token',
    refresh_token: refreshToken
  })
  return axios.post(`${window.apiConfig.APIURL}token`, params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Oauth2'
    }
  })
}

export async function reset (json) {
  return axios.put(`${window.apiConfig.APIURL}api/users/reset`, JSON.stringify(json), {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}
